import React from 'react';
import './AboutUs.css';
import aboutImage from '../Assets/aboutus.png'; // Replace with an appropriate image

const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="about-us-container">
        <div className="about-us-left">
          <img src={aboutImage} alt="About Us" />
        </div>
        <div className="about-us-right">
          <h1>About Us</h1>
          <p>
            Welcome to <strong>Unique Creativity</strong>, your ultimate destination for exclusive and artistic collections. 
            We are passionate about bringing together creativity ,craftsmanship and nature, offering unique products 
            that inspire and elevate your lifestyle.
          </p>
          <p>
            Whether you're looking for stunning artwork, handcrafted designs, or personalized creations or Plants, we have something special for everyone. 
            Our mission is to support artists and creators while delivering high-quality products to our customers.
          </p>
          
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
